// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 572 ? "polySeg" : chunkId) + "." + {"427":"b50db0ed","572":"773acd54","769":"03ace553","856":"647316f8"}[chunkId] + ".chunk.js";
};